import {financeAPI} from "../../axios";

export const actions = {
    createAccountGroup(context, data)
    {
        return financeAPI.post("AccountGroup/CreateAccountGroup", data);
    },
    getAccountGroup(context, data){
        return financeAPI.get(`AccountGroup/${data}`);
    },
    updateAccountGroup(context, {id, data}){
        return financeAPI.put(`AccountGroup/${id}`, data);
    },
    deleteAccountGroup(context, data){
        return financeAPI.delete(`AccountGroup/${data}`);
    },
    getAccountGroupByFundClassification(context, data)
    {
        return financeAPI.get(`AccountGroup/FundClassification/${data}`);
    },
    getAllAccountGroup(){
        return financeAPI.get("AccountGroup/All");
    }
}
